module.exports = __webpack_public_path__ + "static/media/8@3x.e5ffb6f6.png";